import { CardBody } from 'src/components/atoms/CardBody';
import { CardContainer } from 'src/components/atoms/CardContainer';
import { Switch } from 'src/components/atoms/Switch';
import { ShadowsSize } from 'src/components/foundations/tokens';
import {
  Header,
  SettingContainer,
  SettingDescription,
  SettingTitle,
  SubHeader,
} from './ReportingSettingsContainer.styles';

interface Setting {
  title: string;
  descriptions: string[];
  isEnabled: boolean;
  onClick: (newValue: boolean) => void;
}

interface Params {
  header: string;
  subHeader: string;
  settings: Setting[];
}

export const ReportingSettingsContainer = ({
  header,
  subHeader,
  settings,
}: Params) => {
  return (
    <CardContainer $shadowSize={ShadowsSize.large}>
      <CardBody>
        <Header>{header}</Header>
        <SubHeader>{subHeader}</SubHeader>
        {settings.map((setting) => {
          return (
            <>
              <SettingContainer>
                <div>
                  <SettingTitle>{setting.title}</SettingTitle>
                  {setting.descriptions.map((description) => {
                    return (
                      <SettingDescription key={description}>
                        {description}
                      </SettingDescription>
                    );
                  })}
                </div>
                <Switch checked={setting.isEnabled} onClick={setting.onClick} />
              </SettingContainer>
            </>
          );
        })}
      </CardBody>
    </CardContainer>
  );
};
